import React from 'react';

import { MeFragment, useTeamIntegrationsQuery } from '$/GraphQL/schema/schema';

import { useHasChangedShallow } from '$/hooks/useHasChanged';

import type { IntegrationInfo } from '$/sections/Home/Profile/TeamIntegrations/Info';
import { IntegrationFactory } from '$/sections/Home/Profile/TeamIntegrations/Info/IntegrationFactory';
import { InteractionFactory } from './InteractionFactory';

export const useInteractionFactory = (
  forAttendee: boolean,
  me: MeFragment | null | undefined
): InteractionFactory => {
  const [factory] = React.useState(() => new InteractionFactory());

  const integrationsQuery = useTeamIntegrationsQuery({ skip: forAttendee || !me });
  const cardIntegrations: IntegrationInfo[] = React.useMemo(() => {
    return (
      integrationsQuery.data?.teamIntegrations
        ?.map((i) => IntegrationFactory.from(i))
        .filter((i) => i.hasInteractionCards()) ?? []
    );
  }, [integrationsQuery.data?.teamIntegrations]);

  const hasMeChanged = useHasChangedShallow([me], { skipInitial: true });
  React.useEffect(() => {
    if (!hasMeChanged || !me || forAttendee) return;
    integrationsQuery.refetch();
  }, [forAttendee, hasMeChanged, integrationsQuery, me]);

  if (cardIntegrations) {
    factory.cardIntegrations = cardIntegrations;
  }

  const integrations: IntegrationInfo[] = React.useMemo(() => {
    return integrationsQuery.data?.teamIntegrations?.map((i) => IntegrationFactory.from(i)) ?? [];
  }, [integrationsQuery.data?.teamIntegrations]);

  factory.integrations = integrations ?? [];
  factory.loading = integrationsQuery.loading;

  return factory;
};
